export default ({ size }) => {
  return <div className="hsep" style={{ width: size }} />;
};
